import { Component } from '@angular/core';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAK2Bip0xK9RH3budUKyijOZmZF4IVuqtE",
  authDomain: "competitividad21-8aead.firebaseapp.com",
  projectId: "competitividad21-8aead",
  storageBucket: "competitividad21-8aead.appspot.com",
  messagingSenderId: "557639299723",
  appId: "1:557639299723:web:fa1447833701cfa8e81a8e",
  measurementId: "G-XD3X14C5G4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Competitividad21';
}
